module.exports = __webpack_public_path__ + "static/media/completedsavings.afbb1065.svg";